import React from 'react';
import ChevronRight from '../../assets/chevron-right.svg';
import css from './BackToTopButton.module.scss';
import { useTranslation } from 'react-i18next';

export const BackToTopButton: React.FC = () => {
    const { t } = useTranslation('BackToTop');

    const onclick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    return (
        <div className={css.backToTop}>
            <button className={css.button} onClick={onclick}>
                <ChevronRight />
            </button>
            <div>{t('Back to top')}</div>
        </div>
    );
};
